<template>
  <div class="about">
    <h1>Here we have fixed redirecting </h1>
    <p>oude links laten staan in paden, maar herverwijzen naar de nieuwe link</p>
  </div>
</template>
